import React, { useCallback, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import AuthService from '../Services/AuthService';

interface Props {
  errorMessage?: string;
}

const SignInErrorDialog: React.FC<Props> = (props: Props): JSX.Element => {
  const { errorMessage } = props;

  const [open, setOpen] = useState(false);

  const handleErrorDialogClose = useCallback(() => {
    setOpen(false);
    AuthService.signOut();
    window.location.reload();
  }, []);

  return (
    <Dialog open={!!errorMessage && open} onClose={handleErrorDialogClose}>
      <DialogTitle id="alert-dialog-title">Sign in error</DialogTitle>
      <DialogContent>
        <DialogContentText>{errorMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={handleErrorDialogClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignInErrorDialog;
